export type TransferDialogIndex = 'ERROR' | 'LOADING' | 'OPENING' | 'SELECT_ACCTS' | 'SUBMIT' | 'SUCCESS';

export const transferDialogIndexEnums = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING',
  SELECT_ACCTS: 'SELECT_ACCTS',
  SUBMIT: 'SUBMIT',
  SUCCESS: 'SUCCESS',
});
